import type {
	ICellRendererParams,
	ValueFormatterParams,
} from 'ag-grid-community';

import { renderLiveData, zeroDecimalFormatter } from '../tableCustomCellRender';
import type { SourceColumn } from '../useDashboardColumns';

import { labels } from 'locales/en.label';
import { ColumnSources, DEFAULT_COL_WIDTH } from './types';
import { liveDataComparator } from './utils';

export const inventoryColsData: SourceColumn[] = [
	{
		headerName: 'OTB\n(LYST)',
		field: 'current_otb_lyst',
		headerTooltip: labels.rec_review.dashboard.tooltip.otb_lyst,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.INVENTORY,
	},
	{
		headerName: 'OTB\n(LYF)',
		field: 'current_otb_lyf',
		headerTooltip: labels.rec_review.dashboard.tooltip.otb_lyf,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.INVENTORY,
	},
	{
		headerName: 'Group\nBlocked',
		field: 'group_blocked_live',
		headerTooltip: labels.rec_review.dashboard.tooltip.group_blocked,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		cellRenderer: (params: ICellRendererParams) => {
			return renderLiveData(
				{ ...params },
				'group_blocked_live',
				'group_blocked',
				false,
				zeroDecimalFormatter,
			);
		},
		comparator: liveDataComparator('group_blocked'),
		source: ColumnSources.INVENTORY,
	},
	{
		headerName: 'Group\nBooked',
		field: 'group_booked_live',
		headerTooltip: labels.rec_review.dashboard.tooltip.group_booked,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		cellRenderer: (params: ICellRendererParams) => {
			return renderLiveData(
				{ ...params },
				'group_booked_live',
				'group_booked',
				false,
				zeroDecimalFormatter,
			);
		},
		comparator: liveDataComparator('group_booked'),
		source: ColumnSources.INVENTORY,
	},
	{
		headerName: 'OOO',
		field: 'ooo_live',
		headerTooltip: labels.rec_review.dashboard.tooltip.ooo,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		cellRenderer: (params: ICellRendererParams) => {
			return renderLiveData(
				{ ...params },
				'ooo_live',
				'out_of_order',
				false,
				zeroDecimalFormatter,
			);
		},
		comparator: liveDataComparator('out_of_order'),
		source: ColumnSources.INVENTORY,
	},
	{
		headerName: 'Physical\nCapacity',
		field: 'total_capacity',
		headerTooltip: labels.rec_review.dashboard.tooltip.physical_capacity,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.INVENTORY,
	},
	{
		headerName: 'Transient\nCapacity',
		field: 'transient_capacity_live',
		headerTooltip: labels.rec_review.dashboard.tooltip.transient_cap,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		cellRenderer: (params: ICellRendererParams) => {
			return renderLiveData(
				{ ...params },
				'transient_capacity_live',
				'transient_cap',
				false,
				zeroDecimalFormatter,
			);
		},
		comparator: liveDataComparator('transient_cap'),
		source: ColumnSources.INVENTORY,
	},
	{
		headerName: 'Overbooking',
		field: 'overbooking',
		headerTooltip: labels.rec_review.dashboard.overbooking,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.INVENTORY,
	},
];
